import { IOnEnterFunction } from '../types';

export const ensureAll = (onEnters: IOnEnterFunction[]): IOnEnterFunction => {
  return onEnters
    .slice() // copy it so we don't modify it with `.reverse()`
    .reverse() // start at the bottom of the stack
    .reduce(
      (previousOnEnter, onEnter) => {
        // and build up a compound onEnter function, wrapping the next level each iteration
        return (state, nextLocation, onSuccess, onError) => {
          onEnter(state, nextLocation, () => previousOnEnter(state, nextLocation, onSuccess, onError), onError);
        };
      },
      (state, nextLocation, onSuccess, onError) => onSuccess()
    );
};
